"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { id: "app" };
var _hoisted_2 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { style: { "position": "fixed", "text-align": "center", "bottom": "0", "margin": "0 auto", "width": "100%", "color": "#5c6b77" } }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("a", {
        target: "_blank",
        style: { "color": "#5c6b77" },
        href: "https://beian.miit.gov.cn/"
    }, "粤ICP备2024188056号"),
    /*#__PURE__*/ (0, vue_2.createTextVNode)("   @2001 敖途旅行 ")
], -1);
var stores_1 = require("./stores");
exports.default = (0, vue_1.defineComponent)({
    __name: 'App',
    setup: function (__props) {
        var userStore = (0, stores_1.useMemberStore)();
        var handleOpen = function (key, keyPath) {
            console.log(key, keyPath);
        };
        var handleClose = function (key, keyPath) {
            console.log(key, keyPath);
        };
        return function (_ctx, _cache) {
            var _component_RouterView = (0, vue_2.resolveComponent)("RouterView");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createVNode)(_component_RouterView),
                _hoisted_2
            ]));
        };
    }
});
